import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppAppsComponent } from './apps/apps.component';
import { AppAppsViewComponent } from './apps/view/view.component';
import { AppAppsEditComponent } from './apps/edit/edit.component';
import {SharedModule} from "@ecip/shared";

const COMPONENTS = [
  AppAppsComponent];
const COMPONENTS_NOROUNT = [
  AppAppsViewComponent,
  AppAppsEditComponent];

@NgModule({
  imports: [
    SharedModule,
    AppRoutingModule
  ],
  declarations: [
    ...COMPONENTS,
    ...COMPONENTS_NOROUNT,
  ],
  entryComponents: COMPONENTS_NOROUNT
})
export class AppModule { }
